import React, { FC, useState } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';

import { Enquiry } from '../model/enquiry';
import { getOverrides } from '../service/dao/EnquiryDao';

import LinkButton from '../component/LinkButton';
import EnquiryTable, {
  filterColumn,
  enquiryLinks,
  renderBookingStatusUpdated,
  renderEvidenceProvider,
  renderEvidenceRequested,
} from '../component/EnquiryTable/EnquiryTable';

import './ReviewTable.less';

const ReviewTable: FC<{ accessToken: string }> = ({ accessToken }) => {
  const [busy, setBusy] = useState<boolean>(false);
  const { t } = useTranslation();

  const columns = [
    {
      title: t('review.table.appid'),
      dataIndex: 'applicationId',
      render: (id: string, enquiry: Enquiry) => (<LinkButton text={id} url={enquiry.applicationUrl} maxWidth={180} />),
      sorter: true,
      ...filterColumn(t('review.table.appid'), 'applicationId'),
    },
    {
      title: t('review.table.name'),
      dataIndex: 'name',
      render: (_: any, enquiry: Enquiry) => `${enquiry.firstName} ${enquiry.surname}`,
      sorter: true,
      ...filterColumn(t('review.table.name'), 'name'),
    },
    {
      title: t('review.table.last.updated'),
      dataIndex: 'bookingStatusUpdated',
      render: (_: any, enquiry: Enquiry) => (renderBookingStatusUpdated(enquiry.evidenceProviders)),
      sorter: true,
    },
    {
      title: t('review.table.evidence.requested'),
      dataIndex: 'evidenceRequested',
      render: (_: any, enquiry: Enquiry) => (renderEvidenceRequested(enquiry.evidenceProviders)),
      sorter: true,
      ...filterColumn(t('review.table.evidence.requested'), 'evidenceRequested'),
    },
    {
      title: t('review.table.evidence.provider'),
      dataIndex: 'evidenceProvider',
      render: (_: any, enquiry: Enquiry) => (renderEvidenceProvider(enquiry.evidenceProviders)),
      sorter: true,
      ...filterColumn(t('review.table.evidence.provider'), 'evidenceProvider'),
    },
    {
      title: t('review.table.links'),
      dataIndex: 'enquiryId',
      render: (id: string, enquiry: Enquiry) => enquiryLinks(accessToken, enquiry, t, 'review.table.enquiry.', setBusy),
    },
  ];

  return (
    <div className="review-table">
      <EnquiryTable columns={columns} getEnquiries={getOverrides} expandable accessToken={accessToken} />
      <div className="spinner">
        <Spin spinning={busy} />
      </div>
    </div>
)
  ;
};

export default withAuthenticationRequired(ReviewTable, {
});
